import { TextCard } from "../components/TextCard";

export const ThreeCardDetails = () => {
  return (
    <section className={"bg-light-200"}>
      <div className={"flex w-full justify-center items-center"}>
        <div className={"flex flex-col md:w-4/5 py-16 md:py-40"}>
          <div
            className={
              "flex flex-col md:flex-row w-2/3 self-center items-center justify-between text-center md:text-left"
            }
          >
            <h1
              className={
                "text-lg md:text-4xl font-medium md:font-bold text-primary-600"
              }
            >
              Locally Owned, Quality Driven
            </h1>
            <h2 className={"text-lg md:text-2xl text-primary-600"}>
              Values We Live and Work By
            </h2>
          </div>

          <hr className={"border-primary-800 mt-4 md:mt-8 mx-2"} />

          <ul
            className={
              "flex flex-col md:flex-row w-full px-8 pt-16 gap-8 place-content-between"
            }
          >
            <TextCard
              title={"Honesty"}
              text={
                "We believe in upfront communication, fair pricing, and delivering exactly what we promise. When you work with us, you'll always know what to expect. No hidden fees, no upsells, just reliable service from a team that puts integrity first."
              }
              backgroundColor={"bg-light-300"}
            />
            <TextCard
              title={"Integrity"}
              text={
                "Your home or business is an investment, and we treat it as such. Our team takes the time to do the job right, using safe and effective cleaning techniques that protect your property while restoring its original beauty."
              }
              backgroundColor={"bg-light-300"}
            />
            <TextCard
              title={"Quality"}
              text={
                "We don't cut corners. Every job is completed with close attention to detail, ensuring a deep, even clean that enhances curb appeal and extends the life of your surfaces. Whether it's a driveway, storefront, or fleet of trucks, we take pride in delivering top-tier results."
              }
              backgroundColor={"bg-light-300"}
            />
          </ul>
        </div>
      </div>
    </section>
  );
};
